import { render, staticRenderFns } from "./ngobras.vue?vue&type=template&id=3b28f133&"
import script from "./ngobras.vue?vue&type=script&lang=js&"
export * from "./ngobras.vue?vue&type=script&lang=js&"
import style0 from "./ngobras.vue?vue&type=style&index=0&id=3b28f133&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports